import { dataManagerFactory } from 'utils/MobxDataManager/singletons';
import { configurationsStore } from 'utils/MobxDataManager/singletons';
import { IConversationItemEvent } from 'nomst/Stores/Decision/Constants/conversationItemEvent';

export class EventStore {
    employeeEvents: IEmployeeEvent[];

    constructor() {
        this.employeeEvents = [];
    }

    addEvent(employeeSourceId: string, event: IEventNoMst, useEmployeeTopic: boolean): void {
        const employeeEvent = {
            employeeSourceId,
            useEmployeeTopic,
            eventType: event.eventType,
            entityType: event.entityType,
            data: event.data
        } as IEmployeeEvent;

        this.employeeEvents.push(employeeEvent);
    }

    async sendEvents(): Promise<void> {
        const employeeEvents = JSON.parse(JSON.stringify(this.employeeEvents));
        this.employeeEvents = [];

        for (const employeeEvent of employeeEvents) {
            if (employeeEvent.useEmployeeTopic) {
                await dataManagerFactory.getEventDataManager().sendEmployeeEvent(
                    configurationsStore.masterAccountId,
                    employeeEvent.employeeSourceId,
                    configurationsStore.currentConvertedConfiguration.cycleId,
                    {
                        data: employeeEvent.data,
                        entityType: employeeEvent.entityType,
                        eventType: employeeEvent.eventType
                    });

                continue;
            }

            await dataManagerFactory.getEventDataManager().sendEvent(
                configurationsStore.masterAccountId,
                employeeEvent.employeeSourceId,
                configurationsStore.currentConvertedConfiguration.cycleId,
                {
                    data: employeeEvent.data,
                    entityType: employeeEvent.entityType,
                    eventType: employeeEvent.eventType
                });
        }
    }


    async saveEmployeeEvent(employeeSourceId: string, event: IEventNoMst): Promise<void> {
        await dataManagerFactory.getEventDataManager().saveEmployeeEvent(
            configurationsStore.masterAccountId,
            configurationsStore.currentConvertedConfiguration.cycleId,
            employeeSourceId,
            event.eventType,
            event);
    }

    async sendBatchEvents(cycleId: Nullable<number>, events: IEmployeeEvent[]): Promise<void> {
        await dataManagerFactory.getEventDataManager().sendEvents(configurationsStore.masterAccountId, cycleId, events);
    }

    async sendConversationItemEvent(employeeSourceId: string, event: IEventNoMst): Promise<void> {
        await dataManagerFactory.getEventDataManager().sendConversationItemEvent(
            configurationsStore.masterAccountId,
            employeeSourceId,
            {
                data: event.data,
                entityType: event.entityType,
                eventType: event.eventType,
                employeeSourceId
            } as IConversationItemEvent);
    }

    async sendPromotionCommentEvent(employeeSourceId: string, promotionId: string, event: IEventNoMst): Promise<void> {
        await dataManagerFactory.getEventDataManager().sendPromotionCommentEvent(
            configurationsStore.masterAccountId,
            employeeSourceId,
            configurationsStore.currentConvertedConfiguration.cycleId,
            promotionId,
            event);
    }
}